import * as React from 'react';
import { DefaultButton } from 'office-ui-fabric-react';
import { EntitiesScreenSubTypeGroup } from './EntitiesScreenHeader';

type Props = {
    group: EntitiesScreenSubTypeGroup;
    isActive: boolean;
    onSelect?: () => void;
};

export const SubTypeGroupSwitch = ({ group, isActive, onSelect }: Props) => {
    const activeSubType = isActive ? group.subTypes.find(_ => _.isActive()) : undefined;
    return <DefaultButton title={group.title}
        text={isActive ? group.title : undefined}
        iconProps={{ iconName: activeSubType?.iconName ?? group.iconName }}
        className={"screen-view-button sub-type-group-switch" + (isActive ? ' on' : '')}
        menuProps={{
            items: group.subTypes.map(_ => ({
                key: _.title,
                text: _.title,
                iconProps: { iconName: _.iconName },
                onClick: () => {
                    _.onClick();
                    onSelect?.();
                }
            }))
        }} />;
};
